import React, { useState } from "react";
import { RickyTutorial } from "../RickyTutorial";
import { ScreenPortal } from "../MobileZoom";
import { useGlow } from "../PyroTutorial";

const SKILL = '[data-testid="skill-slot-0"]';

function GiftCard({ gift }) {
  return (
    <div data-testid="tutorial-gift" className="fixed left-1/2 top-[18%] -translate-x-1/2 z-[95] pointer-events-none gift-pop">
      <div className="rounded-2xl border-2 border-[#FFE600] bg-[#0A051A]/90 backdrop-blur-md p-4 text-center"
           style={{ boxShadow: "0 0 30px #FFE600aa, 0 0 70px #FF007F66" }}>
        <div className="font-mono text-[10px] tracking-[0.35em] text-[#FFE600]">GIFT FROM RICKY</div>
        <img src={gift.image} alt={gift.name} className="w-28 h-28 mx-auto my-2 object-contain"
             style={{ filter: "drop-shadow(0 0 14px #FFE600)" }} />
        <div className="font-graffiti text-2xl uppercase" style={{ color: "#FF007F", textShadow: "0 0 10px #FF007F, 2px 2px 0 #000" }}>{gift.name}</div>
        <div className="font-mono text-[10px] text-[#C9BDF0] mt-1">Added to your inventory</div>
      </div>
      <style>{`.gift-pop { animation: gift-pop 0.6s cubic-bezier(.2,1.6,.4,1) both; }
        @keyframes gift-pop { 0% { opacity: 0; transform: translate(-50%, 30px) scale(0.4) rotate(-8deg); } 100% { opacity: 1; transform: translate(-50%, 0) scale(1); } }`}</style>
    </div>
  );
}

// stage: "skill" (first skill intro) | "mask" (Tiger Mask gift after first stage advance)
export function TrainingTutorial({ stage, gift, level, onSkillReveal, onDone }) {
  const [glow, setGlow] = useState(null);
  const [showGift, setShowGift] = useState(false);
  useGlow(glow);
  const flash = (sel, ms) => { setGlow(sel); setTimeout(() => setGlow((g) => (g === sel ? null : g)), ms); };

  return (
    <ScreenPortal>
      {stage === "skill" && (
        <RickyTutorial key="skill" noBlock exitAfter onFinish={onDone} steps={[
          { text: `LEVEL ${Math.max(2, level || 2)}! You've earned your FIRST SKILL, Rookie!`, onEnter: () => { onSkillReveal(); setTimeout(() => flash(SKILL, 2200), 500); } },
          { text: "Now advance to the NEXT STAGE and show that wannabe what a real superstar can do! I'll see you there! OWWWWWWW!" },
        ]} />
      )}
      {stage === "mask" && (
        <>
          <RickyTutorial key="mask" noBlock exitAfter onFinish={onDone} steps={[
            { text: "You made it to the next stage, TIGER! Here's a TIGER MASK to match that energy!", onEnter: () => setShowGift(true) },
            { text: "Now head to your WRESTLER PAGE and EQUIP THAT MASK!", onEnter: () => setShowGift(false) },
            { text: "OWWWW! I used to wrestle tigers! Now I pull a hamstring chasing a house cat!" },
          ]} />
          {showGift && gift && <GiftCard gift={gift} />}
        </>
      )}
      <style>{`.pyro-tut-glow { filter: brightness(1.35) drop-shadow(0 0 8px #FFE600) drop-shadow(0 0 20px #FFE600) !important; }`}</style>
    </ScreenPortal>
  );
}
